import { is_prod } from '../../../../globals/utils/constants';

export function toHistoricEffectiveDateIso(raw) {
  if (!raw) {
    return new Date().toISOString();
  }
  if (/^\d{4}-\d{2}-\d{2}$/.test(String(raw).trim())) {
    return String(raw).trim() + 'T12:00:00.000Z';
  }
  return new Date(raw).toISOString();
}

export function buildCommonHistoricPayload(globalState, { userdetails, lawfirmdetails }) {
  const raw = globalState.otherDetails?.effectiveDate;
  const effectiveDate = toHistoricEffectiveDateIso(raw);

  return {
    bond_amount: globalState.basicInformation?.bondAmount,
    premium: globalState.basicInformation?.premiumAmount,
    court_case_number:
      globalState.basicInformation?.hasCourtCaseNumber === 'Yes'
        ? globalState.basicInformation?.courtCaseNumber
        : '',
    state: 6,
    bond_carrier: is_prod ? 7 : 4,
    county: globalState.basicInformation?.county,
    status: 'Approved',
    created_at: effectiveDate,
    updated_at: effectiveDate,
    bond_number: globalState.otherDetails?.bond_number?.bondno_id || '',
    law_firm: globalState.attorneyInformation?.lawFirm,
    law_firm_location: globalState.attorneyInformation?.lawFirmAddress,
    law_firm_user: globalState.attorneyInformation?.attorneyOfRecord,
    obligee: globalState.obligeeInformation?.obligeeId,
    requester_id: userdetails.id,
    managing_lawfirm:
      lawfirmdetails.lawfirmId || globalState.attorneyInformation?.lawFirm,
    requester_user_email: globalState.requestorInformation?.email,
    requester_phone_number: globalState.requestorInformation?.phoneNumber,
    requester_name:
      globalState.requestorInformation?.firstNameReq +
      ' ' +
      globalState.requestorInformation?.lastNameReq,
  };
}
